const mutationConfig = { attributes: false, childList: true, subtree: true };
const intersectionConfig = { threshold: 0.5 };

export default class Impressions {
    constructor(
        impressionsTargetContainerClassName,
        impressionsTargetClassName,
        impressionsTracker,
        impressionCallback
    ) {
        this.impressionsTargetContainerClassName = impressionsTargetContainerClassName;
        this.impressionsTargetClassName = impressionsTargetClassName;
        this.impressionsTracker = impressionsTracker;
        this.impressionCallback = impressionCallback;
    }

    init() {
        // Collect initial containers
        const containers = document.querySelectorAll(`.${this.impressionsTargetContainerClassName}`);

        // Initialize observer instances
        // eslint-disable-next-line compat/compat
        this.intersectionObserverInstance = new IntersectionObserver(
            this.handleImpressions.bind(this),
            intersectionConfig
        );

        this.mutationObserverInstance = new MutationObserver(this.handleContainerTargetsChanges.bind(this));

        // Register initial containers
        containers
            .forEach(this.registerContainer, this);

        // Initialize added/removed container targets handlers
        const { observe, unobserve } = this.intersectionObserverInstance;
        this.handleAddedContainerTarget = this.getContainerTargetsChangesHandler(observe);
        this.handleRemovedContainerTarget = this.getContainerTargetsChangesHandler(unobserve);
    }

    registerContainer(container) {
        this.addImpressionsListeners(container);
        this.addContainerMutationListener(container);
    }

    unregisterContainer(container) {
        this.removeImpressionsListeners(container);
    }

    addImpressionsListeners(container) {
        container.querySelectorAll(`.${this.impressionsTargetClassName}`).forEach(this.addImpressionTargetListener, this);
    }

    removeImpressionsListeners(container) {
        container.querySelectorAll(`.${this.impressionsTargetClassName}`).forEach(this.removeImpressionTargetListener, this);
    }

    addImpressionTargetListener(node) {
        this.intersectionObserverInstance.observe(node);
    }

    removeImpressionTargetListener(node) {
        this.intersectionObserverInstance.unobserve(node);
    }

    addContainerMutationListener(containerElement) {
        this.mutationObserverInstance.observe(containerElement, mutationConfig);
    }

    getContainerTargetsChangesHandler(callback) {
        return (node) => {
            const { nodeType, classList } = node;

            if (nodeType === 1 && classList.contains(this.impressionsTargetClassName)) {
                callback.call(this.intersectionObserverInstance, node);
            }
        };
    }

    handleContainerTargetChange({ addedNodes, removedNodes }) {
        if (removedNodes.length > 0) {
            addedNodes.forEach(this.handleRemovedContainerTarget, this);
        }

        if (addedNodes.length > 0) {
            addedNodes.forEach(this.handleAddedContainerTarget, this);
        }
    }

    handleContainerTargetsChanges(changes) {
        changes.forEach(this.handleContainerTargetChange, this);
    }

    getImpressionHandler(impressionsObserver) {
        return ({ isIntersecting, target }) => {
            if (isIntersecting) {
                impressionsObserver.unobserve(target);

                if (target.parentElement !== null) {
                    this.impressionCallback(target, this.impressionsTracker);
                }
            }
        };
    }

    handleImpressions(impressions, impressionsObserver) {
        impressions.forEach(this.getImpressionHandler(impressionsObserver));
    }
}
